function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { classnames } from '@bydesign-ui/utils';
import { useLocale, usePrefixCls } from '@byte-design/config';
export function TimeBase(props) {
  var className = props.className,
      _props$showHeader = props.showHeader,
      showHeader = _props$showHeader === void 0 ? true : _props$showHeader,
      children = props.children,
      extra = _objectWithoutProperties(props, ["className", "showHeader", "children"]);

  var timeHeaderCls = usePrefixCls('time-panel-header');
  var timeContentCls = usePrefixCls('time-content-wrapper');
  var timePanelCls = classnames(usePrefixCls('time-panel'), className);
  var start = useLocale('date-picker.start');
  var end = useLocale('date-picker.end');
  return React.createElement("div", Object.assign({}, extra, {
    className: timePanelCls
  }), showHeader && React.createElement("div", {
    className: timeHeaderCls
  }, React.createElement("div", null, start), React.createElement("div", null, end)), React.createElement("div", {
    className: timeContentCls
  }, children));
}